<!--<div class="hidden md:flex w-full h-10 bg-gray-200 flex items-center text-center justify-center">
  <h3 class="text-blue-900">SUSCRIBITE HOY Y RECIBÍ LOS <span class="font-semibold">PRIMEROS 3 MESES SIN CARGO</span> USANDO EL CUPÓN: <span class="font-semibold">#quieromiargenfil</span></h3>
</div>-->
<div class="relative z-50">
  <div
    class="w-full flex items-center h-20 bg-primary px-10 shadow-medium transition-all transform ease-in-out duration-700"
    [ngClass]="{
      'fixed -top-20 left-0 w-full translate-y-20 backdrop-blur-md bg-primary/95 shadow-strong':
        scrollPosition >= 100
    }"
  >
    <div class="flex-1 flex-shrink-0">
      <a
        href="#"
        class="text-sm font-bold py-2 transition-transform duration-300 hover:scale-105 inline-block"
      >
        <img
          src="assets/logos/logo-everfull.png"
          class="w-36"
          alt="Logo Everfull"
        />
      </a>
    </div>
    <div
      class="md:flex ml-10 pr-4 flex-shrink-0 items-center align-middle hidden"
    >
      <nav
        aria-label="Global"
        class="flex text-white align-middle justify-end items-center"
      >
        <a
          routerLink="/home"
          class="text-sm font-bold py-2 px-1 hover:text-secondary transition-all duration-300 mr-8 relative group"
          routerLinkActive="active"
          ><span class="relative z-10">Home</span>
          <span
            class="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"
          ></span>
        </a>
        <a
          routerLink="/about-us"
          class="text-sm font-bold py-2 px-1 hover:text-secondary transition-all duration-300 mr-8 relative group"
          routerLinkActive="active"
          ><span class="relative z-10">Quiénes Somos</span>
          <span
            class="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"
          ></span>
        </a>
        <a
          routerLink="/subscription-month"
          class="text-sm font-bold py-2 px-1 hover:text-secondary transition-all duration-300 active:text-secondary mr-8 relative group"
          routerLinkActive="active"
          ><span class="relative z-10">Suscripciones</span>
          <span
            class="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"
          ></span>
        </a>
        <!--
        <a
          routerLink="/sale-product"
          class="text-sm font-bold py-1 hover:text-secondary transition ease-in-out active:text-secondary mr-10"
          routerLinkActive="active"
          >Tienda</a
        >
        -->
        <a
          routerLink="/contact"
          class="text-sm font-bold py-2 px-1 hover:text-secondary transition-all duration-300 mr-8 relative group"
          routerLinkActive="active"
          ><span class="relative z-10">Contacto</span>
          <span
            class="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"
          ></span>
        </a>
        <a
          href="https://everfull.com.ar"
          target="_blank"
          class="text-sm font-bold py-2 px-1 hover:text-secondary transition-all duration-300 mr-8 relative group"
          ><span class="relative z-10">Empresas</span>
          <span
            class="absolute bottom-0 left-0 w-0 h-0.5 bg-secondary transition-all duration-300 group-hover:w-full"
          ></span>
        </a>

        <div *ngIf="user" class="flex items-center">
          <div class="relative group">
            <button
              (click)="toggleUserMenu()"
              class="flex items-center text-white hover:text-secondary transition-all duration-300 user-menu-button bg-white/10 rounded-full px-4 py-2 hover:bg-white/20"
            >
              <img
                src="assets/img_avatar.png"
                alt="Perfil"
                class="w-8 h-8 rounded-full mr-2 ring-2 ring-white/50"
              />
              <span
                class="font-bold text-sm whitespace-nowrap hover:text-secondary"
                >{{ user?.name?.split(",")[1] }}</span
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 ml-2 transition-transform duration-300"
                [class.rotate-180]="userMenuOpen"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <!-- Área invisible para mantener el hover -->
            <div class="absolute w-full h-3 -bottom-3 left-0 z-40"></div>
            <div
              [ngClass]="{
                block: userMenuOpen,
                'hidden group-hover:block': !userMenuOpen
              }"
              class="absolute right-0 top-full mt-3 bg-white rounded-xl shadow-strong z-50 user-menu overflow-hidden"
              style="width: max-content; min-width: 180px"
            >
              <a
                routerLink="/clients"
                (click)="userMenuOpen = false"
                class="block px-5 py-3 text-sm text-primary hover:bg-secondary hover:text-white border-b border-gray-200 font-medium transition-all duration-300"
              >
                <svg
                  class="inline-block w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                Mi perfil
              </a>
              <button
                (click)="logout(); userMenuOpen = false"
                class="block w-full text-left px-5 py-3 text-sm text-primary hover:bg-red-500 hover:text-white font-medium transition-all duration-300"
              >
                <svg
                  class="inline-block w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>

        <button
          *ngIf="!user"
          routerLink="/clients"
          class="text-primary bg-white text-sm rounded-full py-2 px-6 font-bold hover:bg-secondary hover:text-white transition-all duration-300 shadow-soft hover:shadow-medium hover:scale-105"
        >
          Mi perfil
        </button>
      </nav>
    </div>
    <div
      class="absolute inset-y-0 right-0 pr-4 flex items-center sm:pr-6 md:hidden"
    >
      <!-- Mobile menu button -->
      <button
        type="button"
        (click)="menuState = !menuState"
        class="mobile-menu-button -mr-2 text-white inline-flex items-center justify-center p-2 rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="block h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </button>
    </div>
    <!-- Mobile menu, show/hide this `div` based on menu open/closed state -->
    <div
      class="fixed inset-0 z-[60] md:hidden"
      *ngIf="menuState"
      (click)="closeMenu()"
    >
      <div class="block fixed inset-0 z-[60] md:hidden" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-600/50"></div>
      </div>
      <nav
        class="fixed {{
          menuState
            ? 'transition ease-out duration-100 transform opacity-100 scale-100'
            : 'transition ease-in duration-75 transform opacity-0 scale-0'
        }} inset-0 h-full w-full md:hidden z-[70]"
        aria-label="Global"
      >
        <div class="mobile-menu" (click)="$event.stopPropagation()">
          <div
            class="bg-primary h-16 flex items-center justify-between md:px-4 px-6"
          >
            <img src="assets/logos/logo-everfull.png" class="h-8" alt="" />
            <button
              type="button"
              (click)="menuState = !menuState"
              class="-mr-2 inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-white/10 focus:outline-none"
              aria-expanded="false"
            >
              <span class="sr-only">Open main menu</span>
              <svg
                class="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div
            class="max-w-8xl mx-auto py-3 px-2 sm:px-4 bg-white shadow-lg box-shadow"
          >
            <a
              routerLink="/"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Home</a
            >
            <a
              routerLink="/about-us"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Quiénes Somos</a
            >
            <a
              routerLink="/subscription-month"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Suscripciones</a
            >

            <!--
          <a
            routerLink="/sale-product"
            class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
            (click)="closeMenu()"
            >Tienda</a
          >
          -->
            <a
              routerLink="/contact"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Contacto</a
            >
            <a
              href="https://everfull.com.ar"
              target="_blank"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Empresas</a
            >
            <!-- Mi perfil para usuarios logueados (debajo de Contacto) -->
            <a
              *ngIf="user"
              routerLink="/clients"
              class="block rounded-md py-2 px-3 text-base font-medium text-gray-900 hover:bg-gray-100"
              (click)="closeMenu()"
              >Mi perfil</a
            >
            <div *ngIf="!user" class="mt-2 ml-2">
              <a
                routerLink="/clients"
                class="rounded-full bg-secondary py-1 px-4 text-base font-medium text-white hover:bg-gray-100"
                (click)="closeMenu()"
                >Mi perfil</a
              >
            </div>

            <div *ngIf="user" class="border-t border-gray-200 pt-4 pb-3">
              <div class="max-w-8xl mx-auto px-4 flex items-center sm:px-6">
                <div class="flex-shrink-0">
                  <img
                    class="h-10 w-10 rounded-full"
                    src="assets/img_avatar.png"
                    alt=""
                  />
                </div>
                <div class="ml-3 min-w-0 flex-1">
                  <div class="text-base font-medium text-gray-800 truncate">
                    {{ user?.name }}
                  </div>
                  <div class="text-sm font-medium text-gray-500 truncate">
                    {{ user?.email }}
                  </div>
                </div>
              </div>
              <div class="mt-3 max-w-8xl mx-auto px-2 space-y-1 sm:px-4">
                <button
                  (click)="logout()"
                  class="block w-full rounded-md py-2.5 px-3 text-base font-semibold text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                >
                  Cerrar sesión
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <!--</transition>-->
    </div>
  </div>
  <!-- Overlay para cerrar el menú de usuario (desktop) al clickear afuera -->
  <div
    *ngIf="userMenuOpen"
    class="fixed inset-0 z-40"
    (click)="userMenuOpen = false"
  ></div>
</div>
